module.exports = __webpack_public_path__ + "static/media/ic_gold_provider.dfc54e0b.svg";